import api from '@pray/shared/utils/api';
import { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { ApiUnsubscribeGroup, CreateUnsubscribeGroupRequest } from './types';

type Props = { artistId: string; data: CreateUnsubscribeGroupRequest };

export const createUnsubscribeGroup = async ({ artistId, data }: Props) => {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/unsubscribe-groups`;

  const response = await api.executePostRequest<ObjectResponse<ApiUnsubscribeGroup>>(url, data);

  return response.data;
};
